// src/pages/AboutPage.jsx

import React from 'react';
import SpotlightCard from '../components/SpotlightCard/SpotlightCard';
import './AboutPage.css';

const AboutPage = () => {
  return (
    <div className="about-page-container">
      <SpotlightCard
        className="about-card"
        spotlightColor="rgba(255, 165, 0, 0.2)" // Your brand's yellow
      >
        <div className="about-card-content">
          <h2>Two Minds, Infinite Worlds.</h2>
          
          <p className="about-subtitle">
            Krida Studio isn't a large corporation; it's a creative partnership. We are a duo of developers and artists founded on a shared belief: that the most memorable games are born from a singular, unfiltered vision.
          </p>
          
          <h3>Our Philosophy</h3>
          <p>
            In a world of sequels and trends, we choose to explore the uncharted territories of game design. We believe that a unique art style is the soul of a game, and innovative mechanics are its heartbeat. Our mission is to create experiences that surprise, challenge, and stick with you long after you've put down the controller. We don't just build games; we build worlds that beg to be discovered.
          </p>
          
          <h3>Our Craft</h3>
          <p>
            Being a compact team is our strategic advantage. It means every line of code, every brushstroke, and every piece of a world is meticulously crafted and debated between us. There are no committees, no diluted concepts—just pure, concentrated creativity. We are technologically agnostic, choosing our tools—from Unreal Engine to Unity to Blender—to serve the art, not the other way around. This flexibility allows us to build anything we can imagine, ensuring each game has its own distinct identity.
          </p>
          
          <h3>Our Promise to You</h3>
          <p>
            To our players, we make a simple promise: to respect your time and intelligence. We are committed to building complete, polished games that are rich in content and free from distractions. When you play a Krida Studio title, you're not just a user; you're a fellow explorer on a journey we've poured our hearts into.
          </p>
        </div>
      </SpotlightCard>
    </div>
  );
};

export default AboutPage;